/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class AssetLoaderEvent extends alm.event.Event {

		public static META:string = 'AssetLoaderEvent.META';
		public static DEM:string = 'AssetLoaderEvent.DEM';
		public static TRACK:string = 'AssetLoaderEvent.TRACK';
		public static ACTIVITY:string = 'AssetLoaderEvent.ACTIVITY';
		public static COLOR_MAP_ELEVATION:string = 'AssetLoaderEvent.COLOR_MAP_ELEVATION';
		public static COLOR_MAP_GRADIENT:string = 'AssetLoaderEvent.COLOR_MAP_GRADIENT';
		public static USER_IMAGE:string = 'AssetLoaderEvent.USER_IMAGE';

		public static COMPLETE:string = 'AssetLoaderEvent.COMPLETE';

		// pre-loading texture
		public static PHOTO_TERRAIN_TEXTURE:string = 'AssetLoaderEvent.PHOTO_TERRAIN_TEXTURE';






		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object) {
			super(eventType, target);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------
	}
}
